import { FormControl, FormGroup } from '@angular/forms';
import { PropertyMetadata } from '../../../properties/property-types';
import { RegisterElement } from '../../element-decorator';
import { PolygonDecorationMapItem } from '../polygon-decoration-map-item';
import { MeshConstants } from 'src/app/util/mesh-constants';

@RegisterElement()
export class Bush extends PolygonDecorationMapItem {
    public override TypeName: string = 'Bush';

    constructor(formGroup: FormGroup) {
        super(formGroup, "Bush", 'assets/icons/bush.svg', 1, MeshConstants.bushesdistance * 1000);

        if (!formGroup.contains('Name')) {
            formGroup.addControl('Name', new FormControl(''));
        }
    }

    public override clone(): Bush {
        return new Bush(this.formGroup);
    }

    public override getPropertyMetadata(): PropertyMetadata[] {
        return [
            {
                formControlName: 'Name',
                displayName: 'Name',
                inputType: { type: 'text' },
                order: 1,
                category: 'General'
            }
        ];
    }

    public override default(): Bush {
        return this;
    }
}
